import { createSlice } from '@reduxjs/toolkit';
import {
  fetchDoorHandles,
  fetchGroupDoor,
} from '../actions/door.handle.action';
import { roomPriceContextChanged } from '../actions/roomPriceContext.action';

const initialState = {
  door: {
    isLoading: false,
    isNeedReloadData: true,
    data: {},
  },
  groupDoor: { isLoading: false, isNeedReloadData: true, data: [] },
};

export const doorHandleReducer = createSlice({
  name: 'DoorHandle',
  initialState,
  reducers: {
    needReloadDoor: state => {
      state.door = { ...state.door, isNeedReloadData: true };
    },
    needReloadGroupDoor: state => {
      state.groupDoor = { ...state.groupDoor, isNeedReloadData: true };
    },
  },
  extraReducers: builder => {
    builder
      .addCase(roomPriceContextChanged, () => initialState)
      .addCase(fetchDoorHandles.pending, state => {
        state.door = {
          ...state.door,
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(fetchDoorHandles.fulfilled, (state, action) => {
        state.door = {
          ...state.door,
          isLoading: false,
          data: action.payload?.data || {},
        };
      })
      .addCase(fetchDoorHandles.rejected, (state, action) => {
        state.door = {
          ...state.door,
          isLoading: false,
        };
      })
      .addCase(fetchGroupDoor.pending, state => {
        state.groupDoor = {
          ...state.groupDoor,
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(fetchGroupDoor.fulfilled, (state, action) => {
        state.groupDoor = {
          ...state.groupDoor,
          isLoading: false,
          data: action.payload?.data || [],
        };
      })
      .addCase(fetchGroupDoor.rejected, (state, action) => {
        state.groupDoor = {
          ...state.groupDoor,
          isLoading: false,
        };
      });
  },
});

export default doorHandleReducer.reducer;
